import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { identifyViewer, initAnalytics, trackPageView, type AnalyticsViewer } from '@/lib/analytics';

/**
 * Wires analytics to the router and the signed-in viewer. Renders nothing.
 * Mounted once inside the authenticated shell, so it never runs for the
 * sign-in screen or for accounts that are refused staff access.
 *
 * @param props - The viewer identity from `/users/me`.
 * @returns Nothing visible.
 */
export function AnalyticsTracker({ viewer }: { readonly viewer: AnalyticsViewer }): null {
  const location = useLocation();

  // Syncing with an external system (the analytics SDK) is what effects are for.
  useEffect(() => {
    if (initAnalytics()) identifyViewer(viewer);
  }, [viewer]);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search]);

  return null;
}
